document.addEventListener('alpine:init', () => {
    Alpine.data('productComponent', (initialData) => ({
        ...initialData,
        scrolled: false,
        loading: false,
        quantity: 1,
        stickyBarClosed: false,
        formatMoney(val) {
            if (typeof val !== 'number') return val;
            return this.moneyFormat.replace('[price]', val.toFixed(2));
        },
        programmatic: false,
        _scrollToken: 0,
        _progTimer: null,
        // Holds the "programmatic scroll in progress" guard for `delay` ms, then
        // releases it only if this call is still the most recent one (token).
        // A single shared setTimeout fires regardless of scroll precision or tab
        // visibility, and clearing it each call means the newest selection wins.
        _holdGuard(token, delay) {
            clearTimeout(this._progTimer);
            this._progTimer = setTimeout(() => {
                if (token === this._scrollToken) this.programmatic = false;
            }, delay);
        },
        scrollToImage(url) {
            const index = this.productImages.indexOf(url);
            if (index === -1 || !this.$refs.slider) return;
            const slider = this.$refs.slider;
            // A new selection always wins: bump the token so any in-flight
            // release timer from a previous click is ignored.
            const token = ++this._scrollToken;
            this.programmatic = true;
            slider.scrollTo({ left: index * slider.offsetWidth, behavior: 'smooth' });
            this._holdGuard(token, 700);
        },
        scrollToThumb(url) {
            const index = this.productImages.indexOf(url);
            if (index !== -1 && this.$refs.thumbnails) {
                const container = this.$refs.thumbnails;
                const thumb = container.children[index];
                if (thumb) {
                    const containerWidth = container.offsetWidth;
                    const thumbOffset = thumb.offsetLeft;
                    const thumbWidth = thumb.offsetWidth;
                    const scrollLeft = thumbOffset - (containerWidth / 2) + (thumbWidth / 2);
                    container.scrollTo({
                        left: scrollLeft,
                        behavior: 'smooth'
                    });
                }
            }
        },
        handleScroll(e) {
            if (this.programmatic) return;
            const slider = e.target;
            const index = Math.round(slider.scrollLeft / (slider.offsetWidth || 1));
            if (this.productImages[index] && this.currentImage !== this.productImages[index]) {
                this.currentImage = this.productImages[index];
            }
        },
        initGallery() {
            this.$watch('currentImage', (val) => {
                this.scrollToImage(val);
                this.scrollToThumb(val);
            });
            this.$nextTick(() => {
                if (!this.currentImage) return;
                const index = this.productImages.indexOf(this.currentImage);
                if (index !== -1 && this.$refs.slider) {
                    const token = ++this._scrollToken;
                    this.programmatic = true;
                    this.$refs.slider.scrollLeft = index * this.$refs.slider.offsetWidth;
                    // Same tokened guard as scrollToImage: an early thumbnail click
                    // supersedes this and this timer can't clear the guard mid-scroll.
                    this._holdGuard(token, 300);
                }
                this.scrollToThumb(this.currentImage);
            });
        },
        scrollToGallery() {
            if (!window.location.pathname.startsWith('/products/')) return;
            if (window.innerWidth < 768) {
                const gallery = document.querySelector('.product-slider') || document.querySelector('.sticky-top');
                if (gallery) {
                    gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        },
        updateVariant() {
            let variant = this.allVariants.find(v => {
                return v.options.length === this.options.length &&
                       v.options.every((opt, i) => opt === this.options[i]);
            });
            if (variant) {
                this.selectedVariant = variant.id;
                this.price = variant.price;
                this.comparePrice = variant.comparePrice;
                this.available = variant.available;
                if (variant.featured_image) {
                    this.currentImage = variant.featured_image;
                    this.scrollToGallery();
                }
            }
        },
        setQuantity(qty) {
            this.quantity = qty;
            if (this.colorIndex !== undefined && this.colorIndex > -1) {
                let defaultColor = (this.options && this.options[this.colorIndex]) || this.selectedColors[0] || '';
                if (this.selectedColors.length > 0) {
                    this.selectedColors[0] = defaultColor;
                }
                while (this.selectedColors.length < qty) {
                    this.selectedColors.push(defaultColor);
                }
                if (this.selectedColors.length > qty) {
                    this.selectedColors.length = qty;
                }
            }
        },
        setColorOption(idx, value) {
            this.options[idx] = value;
            if (this.colorIndex > -1 && idx === this.colorIndex && this.selectedColors && this.selectedColors.length > 0) {
                this.selectedColors[0] = value;
            }
            this.updateVariant();
        },
        updateBundleQty(qty, bundleValue) {
            if (this.bundleIndex !== undefined && this.bundleIndex > -1) {
                this.options[this.bundleIndex] = bundleValue;
            }
            this.bundleQty = qty;
            while (this.selectedColors.length < qty) {
                this.selectedColors.push(this.selectedColors[0] || '');
            }
            if (this.selectedColors.length > qty) {
                this.selectedColors.length = qty;
            }
            this.updateVariant();
        },
        getCartPayload() {
            let items = [];
            let singleBundleValue = null;
            if (this.bundleIndex !== undefined && this.bundleIndex > -1) {
                let lowestQty = Infinity;
                this.allVariants.forEach(v => {
                    let q = parseInt(v.options[this.bundleIndex]);
                    if (!isNaN(q) && q < lowestQty) {
                        lowestQty = q;
                        singleBundleValue = v.options[this.bundleIndex];
                    }
                });
            }

            if (this.bundleQty > 1 && this.colorIndex > -1 && singleBundleValue) {
                this.selectedColors.forEach(color => {
                    let tempOptions = [...this.options];
                    tempOptions[this.bundleIndex] = singleBundleValue;
                    tempOptions[this.colorIndex] = color;

                    let singleVariant = this.allVariants.find(v => {
                        return v.options.length === tempOptions.length &&
                               v.options.every((opt, i) => opt === tempOptions[i]);
                    });

                    if (singleVariant) {
                        let existing = items.find(i => i.id === singleVariant.id);
                        if (existing) {
                            existing.quantity += this.quantity;
                        } else {
                            items.push({ id: singleVariant.id, quantity: this.quantity });
                        }
                    }
                });
            } else if (this.quantity > 1 && this.colorIndex > -1 && (this.bundleIndex === undefined || this.bundleIndex === -1) && this.selectedColors && this.selectedColors.length === this.quantity) {
                this.selectedColors.forEach(color => {
                    let tempOptions = [...this.options];
                    tempOptions[this.colorIndex] = color;
                    let singleVariant = this.allVariants.find(v => {
                        return v.options.length === tempOptions.length &&
                               v.options.every((opt, i) => opt === tempOptions[i]);
                    });
                    if (singleVariant) {
                        let existing = items.find(i => i.id === singleVariant.id);
                        if (existing) {
                            existing.quantity += 1;
                        } else {
                            items.push({ id: singleVariant.id, quantity: 1 });
                        }
                    }
                });
            } else {
                items.push({ id: this.selectedVariant, quantity: this.quantity });
            }

            if (items.length === 0) return null;
            return { items: items };
        },
        updateColor(idx, value) {
            this.selectedColors[idx] = value;
            if (idx === 0 && this.colorIndex > -1) {
                this.options[this.colorIndex] = value;
                this.updateVariant();
            }
        },
        updateFromId(id) {
            let variant = this.allVariants.find(v => v.id == id);
            if (variant) {
                this.selectedVariant = variant.id;
                this.price = variant.price;
                this.comparePrice = variant.comparePrice;
                this.options = [...variant.options];
                this.available = variant.available;
                if (variant.featured_image) {
                    this.currentImage = variant.featured_image;
                    this.scrollToGallery();
                }
                
                if (this.bundleIndex !== undefined && this.bundleIndex > -1) {
                    this.bundleQty = parseInt(variant.options[this.bundleIndex]) || 1;
                }
                if (this.colorIndex !== undefined && this.colorIndex > -1) {
                    this.selectedColors[0] = variant.options[this.colorIndex];
                }
                while (this.selectedColors.length < this.bundleQty) {
                    this.selectedColors.push(this.selectedColors[0] || '');
                }
                if (this.selectedColors.length > this.bundleQty) {
                    this.selectedColors.length = this.bundleQty;
                }
            }
        },
        isOptionValueAvailable(optionIndex, value) {
            let tempOptions = [...this.options];
            tempOptions[optionIndex] = value;
            let variant = this.allVariants.find(v => {
                return v.options.length === tempOptions.length &&
                       v.options.every((opt, i) => opt === tempOptions[i]);
            });
            return variant ? variant.available : false;
        }
    }));
});
